import React, { Component } from 'react';
import { inject, observer, PropTypes as MobxPropTypes } from 'mobx-react';
import { withCookies, Cookies } from 'react-cookie';
import { instanceOf } from 'prop-types';
import { withRouter } from "react-router-dom";

import OnboardingLayout from '../components/onboarding/OnboardingLayout';
import { Heading2, Heading3, FullWidthWrapper, TextField, PrimaryButton, NoticeText, ErrorText } from '../components/marketing/MarketingStyles';

@inject('userStore', 'mediaStore')
@observer
class Login extends Component {

  constructor(props) {
    super(props)
    this.state = {
      isError: false,
    }
  }

  login = (e) => {
    e.preventDefault();
    const data = e.target
    const userStore = this.props.userStore;
    const cookies = this.props.cookies;
    let username = data.username.value.toLowerCase()

    // log in and check set cookies
    userStore.login(username, data.password.value).then(res => {
      console.log('here');
      if (res === false) {
        this.setState({isError: true});
      } else {
        cookies.set('parseSessionToken', res.sessionToken, { path: '/', maxAge: 60 * 60 * 24 * 365 });
        // cookies.set('parseSessionToken', res.sessionToken, { path: '/internal', maxAge: 60 * 60 * 24 * 365 });

        window.location.replace('/internal')
      }
    })
  }

  render() {

    const globalImage = (key, transform) => {
      return this.props.mediaStore.globalImage(key, transform)
    }
    this.props.mediaStore.media // used to fix a weird rerendering problem

    const Content = () => (
      <FullWidthWrapper key="wrapper">
        <Heading3>The Loge</Heading3>
        <Heading2>Member Login</Heading2>

        <form onSubmit={ this.login }>
          {/* <TextField key="mail" placeholder="E-Mail Adresse" onChange={e => this.setState({ username: e.target.value })} /> */}
          <TextField required name="username" placeholder="E-Mail Adresse" />
          {/* <TextField key="password" placeholder="Passwort" type="password" onChange={e => this.setState({ password: e.target.value })} /> */}
          <TextField required name="password" placeholder="Passwort" type="password" />
          { this.state.isError && <ErrorText>Das Passwort und/oder die Email stimmen nicht überein</ErrorText> }

          <NoticeText style={{ width: '100%', textAlign: 'left'}}><a href="/passwort-vergessen">Passwort vergessen?</a></NoticeText>

          <PrimaryButton
            style={{marginTop: 50}}
            value="login"
          />
        </form>

        <NoticeText>Mit dem Klicken des Button bestätigen Sie unsere <a href="/datenschutz">Datenschutzbestimmungen</a> und die Verarbeitung Ihrer Daten. </NoticeText>
      </FullWidthWrapper>
    )

    const SideContent = () => (
      <img src={globalImage('login_side_image')} style={{height: '100%', width: '100%', objectFit: 'cover', maxHeight: '100vh'}} />
    )

    return (
      <OnboardingLayout content={Content} sideContent={SideContent} />
    )
  }
}

Login.propTypes = {
  userStore: MobxPropTypes.observableObject,
  cookies: instanceOf(Cookies).isRequired
};

export default withRouter(withCookies(Login))



// WEBPACK FOOTER //
// /src/pages/Login.js